import { render } from "./App.vue?vue&type=template&id=013e8618&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=013e8618&lang=scss&scoped=true"

import exportComponent from "../node_modules/.store/vue-loader@17.2.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013e8618"]])

export default __exports__